import React, { Fragment, useEffect, useState } from "react";
import ReportIcon from "root/Reporting/ReportIcon";
import { getYearSurveyStatus, SystemSurveyGenerateStatus, SystemSurveyStatus } from "root/DataFunctions/SystemDataFns";

import './SystemAdminPanel.scss' ;
import ContainerButton from "root/ContainerButton";
import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";

import { ModalGenericModes } from "root/Modals/ModalGeneric/ModalGeneric";
import useModalGenerateSurveys from "root/Modals/ModalGenerateSurveys/useModalGenerateSurveys";

const SystemAdminPanel = ( { image, title, color } ) =>
{
    const [ surveyState, setSurveyState ] = useState ( SystemSurveyStatus.REASON_UNDEFINED )
    const [ surveyAllowed, setSurveyAllowed ] = useState ( SystemSurveyGenerateStatus.RESULT_DO_NOT_ALLOW )
    const [ yearToGenerate, setYearToGenerate ] = useState ( null )

    const [ disabled, setDisabled ] = useState ( false );

    const [ renderGenerateModal, activateGenerateModal ] = useModalGenerateSurveys();

    useEffect ( () =>
    {
        getData() ;
    }, [] );

    const getData = () =>
    {
        getYearSurveyStatus ( ( response ) =>
        {
            const rec = getDataFromResponse ( response )[ 0 ];

            setSurveyState ( rec.reason );
            setSurveyAllowed ( rec.allow );
            setYearToGenerate( rec.year_to_generate );
        } )
    }

    const beforeContent = () =>
    {
        return (
            <Fragment>
                <div style={ { marginTop: '20px', color: '#0A6F7B' } }>We are still in the { yearToGenerate - 1 } academic year for the existing
                    surveys.
                </div>
                <div style={ { marginTop: '20px' } }>You can still run the generation of the { yearToGenerate } surveys early if you wish.</div>
            </Fragment>
        )
    }

    const afterContent = () =>
    {
        return (
            <Fragment>
                <div style={{marginTop: '20px', color: '#0A6F7B'}}>We have now entered the { yearToGenerate } academic year.</div>
                <div style={{marginTop: '20px'}}>You should run the generation of the new surveys now.</div>
            </Fragment>
        )
    }

    const doneContent = () =>
    {
        return (
            <Fragment>
                <div style={{marginTop: '10px', color: '#0A6F7B'}}>The surveys for { yearToGenerate } have been generated and invitations sent.</div>
                <div style={{marginTop: '10px'}}>You do not need to take any further action for this academic year.</div>
            </Fragment>
        )
    }

    const onClickGenerate = () =>
    {
        setDisabled ( true );

        activateGenerateModal ( { title: "Generate Next Year's Survey Requests", mode: ModalGenericModes.COMPLETE, year_to_generate: yearToGenerate})
            .then((response) =>
        {
            if ( response === 'saved')
            {
               getData() ;
            }
            setDisabled ( false ) ;
        });

    }

    const content = () =>
    {
        return (
            <Fragment>
                <div>
                    { surveyState === SystemSurveyStatus.REASON_BEFORE_NEW_ACADEMIC_YEAR_OK && beforeContent () }
                    { surveyState === SystemSurveyStatus.REASON_AFTER_NEW_ACADEMIC_YEAR_OK && afterContent () }
                    { surveyState === SystemSurveyStatus.REASON_DONE && doneContent () }
                </div>
                { surveyAllowed === true && <div style={{marginTop: '20px', paddingRight: '8px'}}>
                    <ContainerButton disabled={ disabled } title='Generate New Surveys' onClick={ onClickGenerate }/>
                </div> }
            </Fragment>
        )
    }

    return (
        <div className='system-content-row' style={ { borderTop: '10px solid ' + color } }>
            <div className='system-content-row-header'>
                <ReportIcon image={ image }/>
                <h4>{ title }</h4>
            </div>
            { surveyState === SystemSurveyStatus.REASON_UNDEFINED && <SpinnerDiv />}
            { surveyState !== SystemSurveyStatus.REASON_UNDEFINED && content() }
            { renderGenerateModal() }
        </div>

    )
}

export default SystemAdminPanel;
